import {Component, Input} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';
import {ChartOptions, ChartType} from 'chart.js';
import {Label} from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector:"participacion-widget",
  templateUrl:"../../templates/widgets/participacion.widget.template.html"
})
export class ParticipacionWidgetComponent {

  public infGraph:any[] = [];

  mostrar:boolean = false;

  @Input()
  nombreParticipante:string = "Colaboradores";


  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'left',
      labels:{
        fontSize:10
      }
    },
    plugins: {
      datalabels: {
        anchor:'center',
        formatter: (value, ctx) => {

          const label = ctx.chart.data.datasets[0].data[ctx.dataIndex] + "%";
          // console.log(ctx.chart.data);
          return label;
        },
        font:{
          size:10
        }
      },
    }
  };
  // public pieChartLabels: Label[] = [['Download', 'Sales'], ['In', 'Store', 'Sales'], 'Mail Sales'];
  // public pieChartData: number[] = [300, 500, 100];
  public pieChartLabels: Label[] = [];
  public pieChartData: number[] = [];
  public pieChartType: ChartType = 'pie';
  @Input()
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
    },
  ];



  constructor(private rs: ReporteServices) {

  }

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {
    this.mostrar = false;
    this.pieChartLabels = [];
    this.pieChartData = [];

    this.rs.devolverReporteParticipacion(entidad, idEntidad, fecha1,fecha2).subscribe(d=>{

      if(d.data.reporteParticipacion){
        let data = JSON.parse(d.data.reporteParticipacion);
        let totalVentas = 0;

        data.participantes.sort((a:any, b:any)=>{
          if(a.nombres > b.nombres)
            return 1;
          else
            return -1;
        });

        data.participantes.map(p=>{
          totalVentas += p.ventas;
        });

        for(let d2 of data.participantes){


          this.pieChartLabels.push(d2.nombres);
          let porc = 0;
          if(totalVentas > 0)
            porc = d2.ventas/totalVentas * 100;

          if(porc > 0)
            porc = parseFloat(porc.toFixed(2));
          this.pieChartData.push(porc);
          // this.infGraph.push({
          //   name:d2.nombres,
          //   value:d2.ventas
          // })
        }


        this.mostrar = true;
      }
    })
  }
}
